import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MeterProvider } from '../../providers/meter/meter';
import { LoginProvider } from '../../providers/login/login';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';


/**
 * Generated class for the ExportMeterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-export-meter',
  templateUrl: 'export-meter.html',
})
export class ExportMeterPage {
  userData: any = {};
  today: Date;
  period : null;
  fromDate:String;
  toDate:String;
  addItem:any = {"from_date":'',"to_date":''};
  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private meterProvider: MeterProvider, 
    private loginProvider:LoginProvider,
    private toast :ToastProvider ) {
    this.today = new Date();
    this.setTime('30');
    loginProvider.profileDetails().then(val => {
  		if(val){
        this.userData = val;
  		}
  	});
  }

  setTime(days){
    this.addItem.from_date =new Date();
    this.addItem.from_date.setDate(this.addItem.from_date.getDate() - days);
    this.addItem.to_date = new Date();
    this.period = days;
  }

  exportdata(data,type){
    if (!data.from_date || !data.to_date){
      this.toast.presentToast("fill from and to date first");
      return;
    }
    if(((data.to_date-data.from_date)/(1000 * 3600 * 24))>90){
      this.toast.presentToast("Kindly select the period of maximum 90 days");
      return;
    }
    this.meterProvider.exportReadingBetweenDates(this.getFormDate(data.from_date),this.getFormDate(data.to_date),this.userData.flat_no,type );
  }

  getFormDate(date){
    if(date){
      let d = date,
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
  
      return [year, month, day].join('-');
    }
    return date;
  }

  setFromDate($event){
    
    this.addItem.from_date =  $event;
    this.fromDate=$event.toISOString();
    this.period =null
  }
  setToDate($event){
    this.addItem.to_date =  $event;
    this.toDate=$event.toISOString()
    this.period = null
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExportMeterPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/export-meter/export-meter.ts